import React from "react";
import { ShieldCheck, CheckCircle2, XCircle, TrendingUp, TrendingDown } from "lucide-react";
import Skeleton from "components/ui/Skeleton";
import { fmtCompact } from "../utils";

const TILE_STYLE = {
  primary: { bg: "bg-primary_tint", text: "text-primary", border: "border-primary/20" },
  success: { bg: "bg-success_bg", text: "text-success", border: "border-success_border" },
  danger: { bg: "bg-danger_bg", text: "text-danger", border: "border-danger_border" },
};

const DeltaBadge = ({ value }) => {
  if (value === null || value === undefined) return null;
  const rising = value >= 0;
  return (
    <span className={`inline-flex items-center gap-0.5 text-[11px] font-medium px-1.5 py-0.5 rounded-md ${rising ? "text-success bg-success_bg" : "text-danger bg-danger_bg"}`}>
      {rising ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
      {Math.abs(value)}%
    </span>
  );
};

const Tile = ({ icon: Icon, label, value, sub, variant, delta }) => {
  const s = TILE_STYLE[variant];
  return (
    <div className="rounded-xl border border-border bg-surface p-4">
      <div className="flex items-start justify-between mb-3">
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border ${s.bg} ${s.border}`}>
          <Icon size={18} className={s.text} />
        </div>
        <DeltaBadge value={delta} />
      </div>
      <p className="text-xl font-bold text-text_primary tabular-nums">{value}</p>
      <p className="text-xs text-text_secondary mt-0.5">{label}</p>
      {sub && <p className="text-[11px] text-text_muted mt-1">{sub}</p>}
    </div>
  );
};

const SystemEmailStatTiles = ({ summary, deltas, loading }) => {
  if (loading) {
    return <Skeleton.Tiles count={3} className="grid-cols-1 sm:grid-cols-3" />;
  }

  const s = summary || {};
  const d = deltas || {};

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <Tile icon={ShieldCheck} label="System Emails Sent" value={fmtCompact(s.total)} sub="auth, notifications & alerts" variant="primary" delta={d.total} />
      <Tile icon={CheckCircle2} label="Delivered Successfully" value={fmtCompact(s.success)} sub={`${s.success_rate ?? 0}% success rate`} variant="success" />
      <Tile icon={XCircle} label="Failed Attempts" value={fmtCompact(s.failed)} sub="delivery failures" variant="danger" />
    </div>
  );
};

export default SystemEmailStatTiles;
